import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
// inspection edit
import { InspectionEditPageComponent } from '../pages/edit.component';
// import { InspectionEditComponent } from '../components/edit.component';

// inspection new
import { InspectionNewPageComponent } from '../pages/new.component';
import { InspectionNewComponent } from '../components/new.component';

import { routedComponents, InspectionEditorRoutingModule } from './inspection-editor.routing';

import { PluginModule } from '../../plugins/modules';
import { SharedModule } from '../../shared.module';

@NgModule({
  imports: [PluginModule, SharedModule, CommonModule, InspectionEditorRoutingModule, FormsModule, ReactiveFormsModule],
  declarations: [routedComponents, InspectionEditPageComponent, InspectionNewPageComponent, InspectionNewComponent]
})
export class InspectionEditorModule {}
